export default function TermsContent() {
    return (
        <>
            <p className="mb-2">
                Our Commitment to Privacy
                <br />
            </p>
            <p className="mb-2">
                At WeKruit, we are committed to protecting your privacy and
                handling your data with the utmost responsibility and
                transparency. This privacy policy outlines how we collect, use,
                protect, and manage your information when you use our AI-powered
                mock interview platform.
            </p>

            <p className="mb-2">
                <strong>Data Collection</strong>
                <br />
                <strong>What Information We Collect</strong>
                <br />
                We collect the following types of information to provide and
                improve our services:
                <br />
                <br />
                <strong>Personal Information</strong>
                <br />
                • Name and email address
                <br />
                • Professional background
                <br />
                • Account credentials
                <br />
                • Contact information you choose to provide
                <br />
                <br />
                <strong>Usage Data</strong>
                <br />
                • Platform interaction data
                <br />
                • Feature usage patterns
                <br />
                • System performance metrics
                <br />
                • Error logs and debugging information
                <br />
                <br />
                <strong>Professional Development Data</strong>
                <br />
                • User-uploaded resumes
                <br />
                • Career preferences
                <br />
                • Industry-specific selections
                <br />
                • Skills and qualifications
                <br />
                • Company preferences and target roles
                <br />
                <br />
                <em>
                    Important Note: WeKruit does not collect, store, or process
                    any facial or audio data from users.
                </em>
            </p>

            <p className="mb-2">
                <strong>How We Use Your Data</strong>
                <br />
                We use your information for the following purposes:
                <br />
                <br />
                <strong>Service Delivery</strong>
                <br />
                • Generating personalized mock interview questions
                <br />
                • Creating customized interview scenarios
                <br />
                • Providing tailored feedback and performance analysis
                <br />
                <br />
                <strong>Platform Improvement</strong>
                <br />
                • Enhancing feature functionality
                <br />
                • Optimizing user experience
                <br />
                • Developing new capabilities
                <br />
                • Analyzing platform performance
                <br />
                <br />
                <strong>Support and Communication</strong>
                <br />
                • Responding to your inquiries
                <br />
                • Sending service-related notifications
                <br />• Providing technical support
            </p>

            <p className="mb-2">
                <strong>Data Sharing and Disclosure</strong>
                <br />
                <strong>Our Policy on Data Sharing</strong>
                <br />
                We maintain strict controls over your data and do not sell it to
                third parties. Data sharing is limited to:
                <br />
                • Third-party service providers necessary for platform operation
                (e.g., hosting, analytics)
                <br />
                • Partners bound by strict confidentiality agreements
                <br />
                • Legal compliance requirements
                <br />
                • With your explicit consent
                <br />
                All service providers are carefully vetted and contractually
                obligated to protect your data.
            </p>

            <p className="mb-2">
                <strong>Your Rights</strong>
                <br />
                You have the following rights regarding your personal data:
                <br />
                • Access: Request a copy of your personal data
                <br />
                • Correction: Update or correct inaccurate information
                <br />
                • Deletion: Request removal of your data from our systems
                <br />
                • Portability: Receive your data in a structured, common format
                <br />• Consent Withdrawal: Opt-out of specific data processing
                activities
            </p>

            <p className="mb-2">
                <strong>Data Security</strong>
                <br />
                We implement robust security measures to protect your
                information:
                <br />
                • Industry-standard encryption protocols
                <br />
                • Secure data storage systems
                <br />
                • Regular security audits
                <br />
                • Strict access controls
                <br />• Ongoing security monitoring
            </p>

            <p className="mb-2">
                <strong>Data Retention</strong>
                <br />
                We retain your data only as long as necessary to:
                <br />
                • Provide our services
                <br />
                • Comply with legal obligations
                <br />
                • Support legitimate business purposes
                <br />
                After this period, your data will be securely deleted or
                anonymized.
            </p>

            <p className="mb-2">
                <strong>Contact Information</strong>
                <br />
                For privacy-related concerns or requests, contact us at:
                <br />
                Email: admin1@wekruit.com
                <br />
                Web: www.wekruit.com/privacy
            </p>

            <p className="mb-2">
                <strong>Disclaimer</strong>
                <br />
                <strong>Purpose of Service</strong>
                <br />
                WeKruit provides AI-powered mock interviews and feedback solely
                for educational and preparation purposes. Our platform is
                designed to help users practice and improve their interview
                skills.
                <br />
                <br />
                <strong>No Guarantees</strong>
                <br />
                WeKruit makes no guarantees regarding:
                <br />
                • Job placement or employment outcomes
                <br />
                • Success in actual interviews
                <br />
                • Specific performance improvements
                <br />
                • Exact alignment with real-world interview processes
                <br />
                <br />
                <strong>Accuracy of Content</strong>
                <br />
                While we strive for accuracy in our mock interview content and
                feedback:
                <br />
                • Questions and scenarios may not perfectly match actual
                interviews
                <br />
                • AI-generated feedback is based on general best practices
                <br />
                • Industry-specific nuances may vary
                <br />
                • Interview practices evolve and change over time
                <br />
                <br />
                <strong>Third-Party Services</strong>
                <br />
                WeKruit integrates with third-party services to provide our
                platform. We:
                <br />
                • Are not liable for third-party service issues
                <br />
                • Cannot guarantee third-party service availability
                <br />
                • May update or change service providers as needed
                <br />
                <br />
                <strong>User Responsibility</strong>
                <br />
                Users acknowledge that:
                <br />
                • Platform usage is at their own discretion
                <br />
                • They are responsible for their decisions and actions
                <br />
                • Success depends on multiple factors beyond interview
                preparation
                <br />
                • The platform is a training tool, not a guarantee of success
                <br />
                <br />
                <strong>Legal Compliance</strong>
                <br />
                This policy complies with applicable data protection
                regulations, including:
                <br />
                • General Data Protection Regulation (GDPR)
                <br />
                • California Consumer Privacy Act (CCPA)
                <br />
                • Other relevant privacy laws and regulations
                <br />
                We regularly review and update our policies to maintain
                compliance with evolving privacy regulations.
            </p>
        </>
    );
}
